import { useLoaderData } from "react-router";

import { appTokenStorage, userAuthDataStorage } from "@storage/sessionStorage";

import { TSessionData, TUserAuthData } from "./types";

export type Session = { hasSession: true; currentAccount: TUserAuthData } | { hasSession: false; currentAccount: null };

export const readSession = (): Session => {
	const token = appTokenStorage.getItem();
	const userData = userAuthDataStorage.getItemAsJson<TUserAuthData>();
	if (token !== null && userData !== null) {
		return { hasSession: true, currentAccount: userData };
	}
	return { hasSession: false, currentAccount: null };
};

export const useSession = (): TSessionData => useLoaderData() as TSessionData;

export const clearSession = async () => {
	localStorage.clear();
	sessionStorage.clear();
	const cookies = document.cookie.split(";");

	for await (const cookie of cookies) {
		const eqPos = cookie.indexOf("=");
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	}
};
